export function XCircleIcon() {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20">
      <path
        d="M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666Z"
        fill="#EF4444"
        fillOpacity="0.12"
      />
      <path
        d="m7.5 7.5 5 5M12.5 7.5l-5 5"
        stroke="#EF4444"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  )
}
